import axios from '../../_utils/axios';
import store, { DELETE_LOADER, persistor } from '../../../store';
import { format } from '../../../utils/format';

// ----------------------------------------------------------------------

const getAlarms = async (
  setData: React.Dispatch<React.SetStateAction<{
    content: any[];
    totalElements: number;
    totalPages: number;
  }>>,
  id: string,
  startDate: Date,
  endDate: Date,
  interval: string,
  { location, waterQuality }: { location: string, waterQuality: string },
  { page, size }: { page: number, size: number }
) => {
  const start = format(startDate, interval === 'setting' ? 'daily' : interval, 'start');
  const end = format(endDate, interval === 'setting' ? 'daily' : interval, 'end');

  return await axios.get(`water-quality-alarms/iot-groups/${id}/search-page?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}&location=${location}&waterQuality=${waterQuality}&page=${page}&size=${size}`)
    .then((response) => {
      return setData(response.data.data);
    })
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        return window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        return window.location.href = '/login';
      }
    })
    .finally(() => store.dispatch( DELETE_LOADER() ));
};

export default getAlarms;